import { render } from "./StatusBadge.vue?vue&type=template&id=1c670208&scoped=true"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"

import "./StatusBadge.vue?vue&type=style&index=0&id=1c670208&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c670208"]])

export default __exports__